// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOcrServiceOptionDto
 */
export interface IOcrServiceOptionDto {
    /**
     * 
     * @type {number}
     * @memberof IOcrServiceOptionDto
     */
    service_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IOcrServiceOptionDto
     */
    service_name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IOcrServiceOptionDto
     */
    is_suggested?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IOcrServiceOptionDto
     */
    category_type?: IOcrServiceOptionDtoCategoryTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IOcrServiceOptionDtoCategoryTypeEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}


/**
 * Check if a given object implements the IOcrServiceOptionDto interface.
 */
export function instanceOfIOcrServiceOptionDto(value: object): value is IOcrServiceOptionDto {
    return true;
}

export function IOcrServiceOptionDtoFromJSON(json: any): IOcrServiceOptionDto {
    return IOcrServiceOptionDtoFromJSONTyped(json, false);
}

export function IOcrServiceOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrServiceOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'service_id': json['service_id'] == null ? undefined : json['service_id'],
        'service_name': json['service_name'] == null ? undefined : json['service_name'],
        'is_suggested': json['is_suggested'] == null ? undefined : json['is_suggested'],
        'category_type': json['category_type'] == null ? undefined : json['category_type'],
    };
}

export function IOcrServiceOptionDtoToJSON(json: any): IOcrServiceOptionDto {
    return IOcrServiceOptionDtoToJSONTyped(json, false);
}

export function IOcrServiceOptionDtoToJSONTyped(value?: IOcrServiceOptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'service_id': value['service_id'],
        'service_name': value['service_name'],
        'is_suggested': value['is_suggested'],
        'category_type': value['category_type'],
    };
}

